import { createContext, Dispatch, SetStateAction } from "react";

const layoutColorMode: string = "";
const setLayoutColorMode: Dispatch<SetStateAction<string>> = () => {};

export default createContext({
 layoutColorMode,
 setLayoutColorMode,
});
